export function caseTitle(item) {
  const code = String(item.project_code || '').trim();
  let title = String(item.title || '').trim();
  if (!code) return title;
  const escaped = code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const prefix = new RegExp(`^\\*?\\s*${escaped}(?=$|[\\s.:–—·-])[\\s.:–—·-]*`, 'i');
  let starred = false;
  while (prefix.test(title)) {
    starred ||= title.startsWith('*');
    title = title.replace(prefix, '').trim();
  }
  return `${starred ? '*' : ''}${code}${title ? `. ${title}` : ''}`;
}
